import axios from '@/plugins/axios'
import { Module } from 'vuex'

const commentsModule: Module<any, any> = {
    actions: {
        async getComments(_, params) {
            let url = '/api/comments?ts=' + Date.now()

            url += params.page ? '&page=' + params.page : ''
            url += params.perPage ? '&itemPerPage=' + params.perPage : ''
            url += params.open ? '&open=' + (params.open ? 1 : 0) : ''
            url += params.deleted ? '&deleted=' + +(params.deleted ? 1 : 0) : ''
            url += params.resolved
                ? '&resolved=' + (params.resolved ? 1 : 0)
                : ''
            url += params.responseStatus
                ? '&response-status=' + params.responseStatus
                : ''
            // One comments inbox list (open, in-review, resolved-ok, ...)
            url += params.status
                ? '&status=' + encodeURIComponent(params.status)
                : ''
            url += params.workspaceMemberId
                ? '&noresponses=1&workspaceMemberId=' + params.workspaceMemberId
                : '&noresponses=1'
            url += params.postId
                ? '&postId=' + params.postId
                : ''
            url += params.commentedByNetworkConnectionId
                ? '&commentedByNetworkConnectionId=' + params.commentedByNetworkConnectionId
                : ''
            url += params.showNonExecutiveComment
                ? '&showNonExecutiveComment=1'
                : '&showNonExecutiveComment=0'

            const { data } = await axios.get(url)

            return data
        },
        async getComment(_, params) {
            const url = '/api/comments/' + params.id + '?ts=' + Date.now()
            const { data } = await axios.get(url)
            return data
        },
        async getResponses(_, params) {
            const url =
                '/api/commentspending?commentId=' +
                params.commentId +
                '&ts=' +
                Date.now()

            const { data } = await axios.get(url)
            return data
        },
        async deleteComment(_, params) {
            await axios.delete(`/api/comments/${params.id}?note=${encodeURIComponent(params.note)}`)
        },
        // WARN: DOES THIS EVEN WORK?
        async deleteComments(_, params) {
            for (const id of params.ids) {
                await axios.delete(`/api/comments/${id}?note=${encodeURIComponent(params.note)}`)
            }
        },
        async replyComment(_, params) {
            await axios.put(`/api/comments/${params.id}/respond`, {
                comment: params.comment,
                commentingNetworkConnectionId:
                    params.commentingNetworkConnectionId ?? null,
            })
        },
        async resolveComment(_, { id, resolved }) {
            await axios.put(`/api/comments/${id}/resolve`, {
                resolved,
            })
        },
        async approveResponse(_, params) {
            await axios.put(`/api/commentspending/${params.id}/approve`, {})
        },
        async rejectResponse(_, { id, note }) {
            await axios.put(`/api/commentspending/${id}/reject`, { note })
        },
        async suggestResponse(_, { id, note }) {
            await axios.put(`/api/commentspending/${id}/suggest`, { note })
        },
        async publishResponse(_, id) {
            await axios.put(`/api/commentspending/${id}/publish`, {})
        },
        async deleteResponse(_, id) {
            await axios.delete(`/api/commentspending/${id}`)
        },
        async editResponse(_, { id, comment }) {
            await axios.put(`/api/commentspending/${id}`, { comment })
        },
        async exportComments(_, params) {
            let url = '/api/comments/export?ts=' + Date.now()

            url += params.page ? '&page=' + params.page : ''
            url += params.perPage || params?.perPage===0 ? '&itemPerPage=' + params.perPage : ''
            url += params.workspaceMemberId
                ? '&noresponses=1&workspaceMemberId=' + params.workspaceMemberId
                : '&noresponses=1'

            const { data } = await axios.get(url)

            return data
        },

    },
}

export default commentsModule
